import React from 'react';
import './index.css';
import TextToSpeech from './txtTospeech.js';

export default function Work() {
  return (
    <div className="sectionComponent">
      <h1>WORK</h1>
      <TextToSpeech
        inputText={
          'University of Southern California. Teaching Assistant - ITP 115. Assist students enrolled in Python class with their assignments, as well as grade and assist in other aspects of teaching the course. Slalom. Associate Software Engineer. Software Engineer Intern. Developed front-end of web application for clients using JavaScript, TypeScript, and React '
        }
      ></TextToSpeech>
      <dl>
        <dt>University of Southern California</dt>
        <dd>Teaching Assistant - ITP 115</dd>
        <dd>
          Assist students enrolled in Python class with their assignments, as
          well as grade and assist in other aspects of teaching the course
        </dd>
        <dt>Slalom</dt>
        <dd>Associate Software Engineer</dd>
        <dd>Will be working on a variety of projects involving full-stack development using Typescript, React, and Node.</dd>
        <dd>Software Engineer Intern</dd>
        <dd>
          Developed front-end of web application for clients using JavaScript,
          TypeScript, and React. Implemented the MUI design library to maintain consistent stuling and user-friendly design throughout the web application. Also learned how to deploy websites using cloud technologies such as Azure DevOps. 
        </dd>

 </dl>
    </div>
  );
}
